import { bindStateTabs } from "../consts/stateTabs";

//! @ngInject
export function callsCtrl(
    $scope,
    $state
) {
    // In the order calls.html renders them, and the destinations the AI omnibar offers for this
    // page - see the `tabs` beside it in config.js.
    const tabs = bindStateTabs($scope, $state, [
        "app.evv.calls.maintenance",
        "app.evv.calls.rejected"
    ]);

    $scope.goToState = tabs.goToState;
};
